module.exports = __webpack_public_path__ + "static/img/preview-04.54b72ab0.webp";